/* 🤖 this file was generated by svg-to-ts */
export const mgcIconHeartFilled: {
  name: 'heart-filled';
  data: string;
} = {
  name: 'heart-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.7 3.043a6.202 6.202 0 0 0-2.909 1.248 8.427 8.427 0 0 0-1.4 1.471C2.197 7.445 1.732 9.703 2.167 11.72c.561 2.609 2.722 5.319 5.953 7.467C9.614 20.181 11.367 21 12 21s2.392-.822 3.88-1.813c2.472-1.647 4.283-3.568 5.283-5.607.666-1.358.918-2.598.805-3.966-.091-1.1-.316-1.918-.791-2.874-.39-.785-.721-1.245-1.356-1.883-.922-.925-1.929-1.49-3.112-1.744-.588-.126-1.594-.125-2.187.002-.782.168-1.433.455-2.152.95L12 4.32l-.37-.255c-1.016-.699-1.957-1.016-3.11-1.046a6.66 6.66 0 0 0-.82.024"/></svg>`
};
